import React from 'react';
import DataRequestGuide from '../../components/DataRequestGuide';
const steps = [
    {
        id: 'mistral-step-1',
        stepLabel: 'Step 1',
        title: 'Where should you begin?',
        image: process.env.PUBLIC_URL + '/Images/steps/Mistral_Step1.png',
        imageAlt: 'Mistral home screen with menu icon highlighted',
        body: (
        <>
            Open the Mistral app or go to{' '}
            <a href="https://chat.mistral.ai/chat" target="_blank" rel="noreferrer">
            mistral.ai
            </a>
            , then press on the two horizontal bars at the top left of the screen.
            (If the side menu is already visible, you can skip this step.)  
        </>
        ),
    },
    {
        id: 'mistral-step-2',
        stepLabel: 'Step 2',
        title: 'Open your profile menu',
        image: process.env.PUBLIC_URL + '/Images/steps/Mistral_Step2.png',
        imageAlt: 'Profile icon highlighted in Mistral',
        body: (
        <>
            Click on your profile icon, located where your username appears at the
            bottom left of the menu.
        </>
        ),
    },
    {
        id: 'mistral-step-3',
        stepLabel: 'Step 3',
        title: 'Go to Profile Settings',
        image: process.env.PUBLIC_URL + '/Images/steps/Mistral_Step3.png',
        imageAlt: 'Profile option highlighted in Mistral menu',
        body: (
        <>
            In the pop-up menu, click on <strong>Profile</strong>.
        </>
        ),
    },
    {
        id: 'mistral-step-4',
        stepLabel: 'Step 4',
        title: 'Open Data ',
        image: process.env.PUBLIC_URL + '/Images/steps/Mistral_Step4.png',
        imageAlt: 'Export button highlighted in settings',
        body: (
        <>
            In the settings panel, press the <strong>Export</strong> button. 
        </>
        ),
    },
        {
        id: 'mistral-step-4',
        stepLabel: 'Step 5',
        title: 'Download export',
        image: process.env.PUBLIC_URL + '/Images/steps/Mistral_Step5.png',
        imageAlt: 'In the same panel, click Download once it appears. Your file will begin downloading automatically.',
        body: (
        <>
        </>
        ),
    },
];

const MistralRequest = () => {
    return (
        <DataRequestGuide
        title="How to Request Your Mistral Data"
        intro="Follow these steps to export a copy of your Mistral data, which you can then donate through this website."
        steps={steps}
        />
    );
};

export default MistralRequest;
